export default {"src":"/_next/static/media/label-bg.b820e4f3.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};